<div class="profile-container">
    <div class="">
        <div class="profile-content">    
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" (keyup.enter)="getAllAssetDepreciationMethodByWildSearch()" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
                            </form>
                            <i class="bi bi-search" (click)="getAllAssetDepreciationMethodByWildSearch()"></i>
                        </div>
                        <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#budgetModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th style="width: 25%;">{{ 'asset-budgeting.financialYear' | translate }}</th>
                        <th style="width: 25%;">{{ 'asset-budgeting.branch' | translate }}</th>
                        <th style="width: 25%;">{{ 'asset-budgeting.location' | translate }}</th>
                        <th style="width: 25%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.assetBudgetingId == recordId }" *ngFor="let list of assetBudgetingDataList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">

                        <p style="width: 25%;">{{list.financialYear || '--'}}</p>
                        <p style="width: 25%;">{{list.branch || '--'}}</p>
                        <p style="width: 25%;">{{list.location || '--'}}</p>
                        <p class="action-buttons" style="width: 25%;padding-left: 25px;">
                          <i data-toggle="modal" title="View" (click)="getAssetBudgetingIdById(list.assetBudgetingId)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                          <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square" (click)="getAssetBudgetingIdById(list.assetBudgetingId)" data-toggle="modal" data-target="#editModal" ></i>
                          <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3" (click)="deleteIdSelect(list.id,list)" data-toggle="modal" data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader"  *ngIf="!isLoading && assetBudgetingDataList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteAssetBudgeting()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div
  class="modal fade"
  id="budgetModal"
  tabindex="-1"
  data-backdrop="static"
  aria-labelledby="budgetModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="budgetModalLabel">{{ 'asset-budgeting.headings.add' | translate }}</h5>
        <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="addForm" (ngSubmit)="addAssetBudgeting()">

          <div class="row">
            <div class="col-md-6">
              <label>{{ 'asset-budgeting.financialYear' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="financialYear">
                <option value="" disabled selected>-- Select Year --</option>
                <option *ngFor="let list of yearList" [value]="list.year">{{ list.year }}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label>{{ 'asset-budgeting.branch' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="branch">
                <option value="" disabled selected>-- Select Branch --</option>
                <option *ngFor="let list of branchList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>

            <div class="col-md-6 mt-3">
              <label>{{ 'asset-budgeting.location' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="location">
                <option value="" disabled selected>-- Select Location --</option>
                <option *ngFor="let list of locationList" [value]="list.city">{{ list.city }} - {{ list.postalCode }}</option>
              </select>
            </div>
          </div>

          <div formArrayName="budgetData" class="mt-4">
            <div
              *ngFor="let item of budgetData.controls; let i = index"
              [formGroupName]="i"
              class=""
            >
              <div class="row data-list">

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.assetName' | translate }} <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="assetName">
                    <option value="" disabled selected>-- Select Asset --</option>
                    <option *ngFor="let list of objectInfoList" [value]="list.givenName">{{ list.givenName }}</option>
                  </select>
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.noOfUnits' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="noOfUnits"
                    (keyup)="calculateTotal(i)"
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.pricePerUnit' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="pricePerUnit"
                    (keyup)="calculateTotal(i)"

                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.totalValue' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="totalValue"
                    style="cursor: not-allowed;"
                    readonly
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.currency' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="currency"
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.uom' | translate }} <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="uom">
                    <option value="" disabled selected>-- Select UOM --</option>
                    <option *ngFor="let list of uomData" [value]="list.uomName">{{ list.uomName }}</option>
                  </select>
                </div>
              </div>

              <div class="data-list-action">
                <button
                  type="button"
                  (click)="removeBudgetItem(i)"
                  *ngIf="budgetData.length > 1"
                >
                  <i class="bi bi-trash"></i> {{ 'generic.remove' | translate }}
                </button>
                <button type="button" class="" (click)="addBudgetItem()">
                  <i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" id="closeModalAdd" (click)="closeModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
            <button type="submit" class="btn btn-primary">{{ 'generic.submit' | translate }}</button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div
  class="modal fade"
  id="editModal"
  tabindex="-1"
  data-backdrop="static"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-budgeting.headings.edit' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="updateForm" (ngSubmit)="updateAssetBudgeting()">

          <div class="row">
            <div class="col-md-6">
              <label>{{ 'asset-budgeting.financialYear' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="financialYear">
                <option value="" disabled selected>-- Select Year --</option>
                <option *ngFor="let list of yearList" [value]="list.year">{{ list.year }}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label>{{ 'asset-budgeting.financialYear' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="branch">
                <option value="" disabled selected>-- Select Branch --</option>
                <option *ngFor="let list of branchList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>

            <div class="col-md-6 mt-3">
              <label>{{ 'asset-budgeting.financialYear' | translate }} <span class="required">*</span></label>
              <select class="form-control" formControlName="location">
                <option value="" disabled selected>-- Select Location --</option>
                <option *ngFor="let list of locationList" [value]="list.city">{{ list.city }} - {{ list.postalCode }}</option>
              </select>
            </div>
          </div>

          <div formArrayName="budgetData" class="mt-4">
            <div
              *ngFor="let item of budgetUpdateData.controls; let i = index"
              [formGroupName]="i"
              class=""
            >
              <div class="row data-list">

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.assetName' | translate }} <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="assetName">
                    <option value="" disabled selected>-- Select Asset --</option>
                    <option *ngFor="let list of objectInfoList" [value]="list.givenName">{{ list.givenName }}</option>
                  </select>
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.noOfUnits' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="noOfUnits"
               
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.pricePerUnit' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="pricePerUnit"
             
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.totalValue' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="totalValue"
                    readonly
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.currency' | translate }} <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="currency"
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label>{{ 'asset-budgeting.uom' | translate }} <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="uom">
                    <option value="" disabled selected>-- Select UOM --</option>
                    <option *ngFor="let list of uomData" [value]="list.uomName">{{ list.uomName }}</option>
                  </select>
                </div>
              </div>

              <div class="data-list-action">
                <button
                  type="button"
                  (click)="removeUpdateBudgetItem(i)"
                  *ngIf="budgetUpdateData.length > 1"
                >
                  <i class="bi bi-trash"></i> {{ 'generic.remove' | translate }}
                </button>
                <button
                  type="button"
                  (click)="addUpdateBudgetItem()"
                >
                  <i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" d="closeModalUpdate" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
            <button type="submit" class="btn btn-primary">{{ 'generic.submit' | translate }}</button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>







<!-- Budgeting Details Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewModalLabel">{{ 'asset-budgeting.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of assetBudgetingData">
          <div class="form-group">
            <div class="row">

              <div class="col-md-6">
                <label>{{ 'asset-budgeting.assetBudgetingId' | translate }} :</label>
                <p>{{ viewData.assetBudgetingId || '--' }}</p>
              </div>


              <div class="col-md-6">
                <label>{{ 'asset-budgeting.financialYear' | translate }} :</label>
                <p>{{ viewData.financialYear || '--' }}</p>
              </div>

              <div class="col-md-6">
                <label>{{ 'asset-budgeting.branch' | translate }} :</label>
                <p>{{ viewData.branch || '--' }}</p>
              </div>

    

              <div class="col-md-6">
                <label>{{ 'asset-budgeting.location' | translate }} :</label>
                <p>{{ viewData.location || '--' }}</p>
              </div>

              <div class="col-md-12" *ngIf="viewData.budgetData || viewData.budgetData.length != 0">
                <div class="status-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 25%;">{{ 'asset-budgeting.assetName' | translate }}</th>
                        <th style="width: 25%;text-align: center;">{{ 'asset-budgeting.noOfUnits' | translate }}</th>
                        <th style="width: 25%;text-align: center;">{{ 'asset-budgeting.pricePerUnit' | translate }}</th>
                        <th style="width: 25%;text-align: center;">{{ 'asset-budgeting.totalValue' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let budget of viewData.budgetData; let i = index">
                        <td style="width: 25%;">{{budget.assetName}}</td>
                        <td style="width: 25%;text-align: center;">{{budget.noOfUnits}}</td>
                        <td style="width: 25%;text-align: center;">{{budget.pricePerUnit}}</td>
                        <td style="width: 25%;text-align: center;">{{budget.totalValue}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div> 
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeBudgetingModal" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>
